import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

interface InfoWithLabelProps {
  label: string;
  children: React.ReactNode;
  subMessage?: string;
  fullWidth?: boolean;
  className?: string;
}

export const InfoWithLabel = ({
  label,
  children,
  subMessage,
  fullWidth = true,
  className,
}: InfoWithLabelProps) => (
  <Stack
    align="start"
    gap={2}
    className={cn(className, { "w-full": fullWidth })}
  >
    <Text variant="label" tone="muted">
      {label}
    </Text>
    {/* Any value, not only a string, gets body text, so a number or an
        element doesn't fall back to the inherited 16px. */}
    <Text render={<div />} className="w-full">
      {children}
    </Text>
    {subMessage && (
      <Text variant="caption" tone="muted">
        {subMessage}
      </Text>
    )}
  </Stack>
);
